import { filesUrl } from '@/shared/constants'
import { StoriesInfo } from '../types'
import { http } from '@/shared/http.ts'

export const getStoriesInfo = async (token: string) => {
  return await http.get<StoriesInfo>('/user/stories-info', {
    token,
  })
}

export const postUploadStories = async (token: string, image: FormData) => {
  // TODO: clarify this type
  return await http.post<any>(`${filesUrl}_files/upload/`, {
    token,
    body: image,
  })
}
